// import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  submitOrder: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.submitOrder(data)
        .then(result => {
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-order/store/actions.js